import React from "react";
import { Layout } from "antd";
import DiscoveryFilter from "./DiscoveryFilter";
import DiscoveryItems from "./DiscoveryItems";

const {Content} = Layout;

const DiscoveryOverview = () => { 

    return (
        <div className="container mx-auto pt-162 min-h-calc-head h-full">
            <Layout className="bg-transparent h-full">
                <Content className="pt-8 pb-8 pl-10 pr-10 sm:pr-10">
                    <DiscoveryFilter />
                                            
                        <DiscoveryItems title="Popular Metahuts Today" type="popular" limit="4" image="popular.svg" />
    
                        <DiscoveryItems title="Featured Metahuts" type="featured" limit="4" image="featured.svg" />
                        
                        <DiscoveryItems title="Top-rated Metahuts" type="rate" limit="4" image="rated.svg" />
    
                        <DiscoveryItems title="Recently Created Metahuts" type="recent" limit="4" image="recently.svg" />

                </Content>
            </Layout>
        </div>
    )
}

export default DiscoveryOverview;